import { observable } from 'mobx';

// ? [REVISIT] Buidler breaks when rendered inside the top level providers (specifically react router). This state exists to help render them as seperate react trees BUT also still pass data between them, by lifting the state up / outside of react.
const state = {
  productTags: [] as string[],
  productType: '',
  setProductTags(productTags: string[]) {
    this.productTags = productTags;
  },
  setProductType(type: string) {
    this.productType = type;
  },
};

const PdpBuilderState = observable(state);

export { PdpBuilderState };
